import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { Flex, TextButton, Tooltip } from '@ads/front-ds'
import { Separator } from '@ads/front-core/atoms'
import { lng } from '@ads/front-core/locales'
import { copyToClipboard } from '@ads/front-core/utils'

interface ICreationPreviewActions {
  previewExternalUrls?: string[]
  publicPreviewUrl?: string
  showLabel?: boolean
}

export const CreationPreviewActions: FC<ICreationPreviewActions> = ({
  previewExternalUrls,
  publicPreviewUrl,
  showLabel,
}) => {
  const dispatch = useDispatch()

  const handleCopy = (content: string) => {
    copyToClipboard(content, dispatch)
  }

  const copyPreviewExternalUrls = () => {
    const urls = previewExternalUrls.map(url => {
      try {
        const parsedUrl = new URL(url)
        parsedUrl.hostname = 'www.wp.pl'
        return parsedUrl.toString()
      } catch (error) {
        console.error('Invalid URL in getPreviewExternalUrls:', url, error)
        return url
      }
    })
    handleCopy(urls.join('\n'))
  }

  return (
    <Flex gap="xs" alignItems="center">
      {previewExternalUrls?.length > 0 && (
        <>
          <TooltipStyled
            text={lng('campaign:openPreviewInExternalSource')}
            placement="left"
            hide={showLabel}
          >
            <TextButton
              iconBefore="20-link-external"
              onClick={() => window.open(previewExternalUrls[0], '_blank')}
            >
              {showLabel && lng('campaign:openPreviewInExternalSource')}
            </TextButton>
          </TooltipStyled>
          <VerticalLine />
          <TooltipStyled
            text={lng('campaign:copyLinksToExternalPreview')}
            placement="left"
            hide={showLabel}
          >
            <TextButton
              ml={showLabel ? undefined : 'xxs'}
              iconBefore="20-copy"
              onClick={copyPreviewExternalUrls}
            >
              {showLabel && lng('campaign:copyLinksToExternalPreview')}
            </TextButton>
          </TooltipStyled>
          {publicPreviewUrl && <VerticalLine />}
        </>
      )}
      {Boolean(publicPreviewUrl) && (
        <TooltipStyled
          text={lng('campaign:copyLink')}
          placement="left"
          hide={showLabel}
        >
          <TextButton
            iconBefore="20-copy"
            onClick={() => handleCopy(publicPreviewUrl)}
          >
            {showLabel && lng('campaign:copyLink')}
          </TextButton>
        </TooltipStyled>
      )}
    </Flex>
  )
}

const TooltipStyled = styled(Tooltip)`
  & > div {
    display: flex;
  }
`

const VerticalLine = styled(Separator)`
  height: 26px;
`
